"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffersDragDropProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var OffersDragDropProvider = exports.OffersDragDropProvider = function OffersDragDropProvider(_ref) {
  var children = _ref.children,
    onDragEnd = _ref.onDragEnd;
  return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "Basket",
    type: "Basket"
  }, function (dropProvided) {
    return /*#__PURE__*/_react.default.createElement("div", _extends({
      ref: dropProvided.innerRef
    }, dropProvided.droppableProps), children, dropProvided.placeholder);
  }));
};
OffersDragDropProvider.propTypes = {
  onDragEnd: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
};